import React from "react";

interface ReportedUserFilterToolbarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  sortOrder: string;
  onSortChange: (value: string) => void;
}

const ReportedUserFilterToolbar: React.FC<ReportedUserFilterToolbarProps> = ({
  searchTerm, onSearchChange, sortOrder, onSortChange
}) => {
  return (
    <div className="py-3 px-4 md:px-7 border-b border-gray-200 bg-white flex flex-col md:flex-row gap-3 md:items-center shrink-0">
      <div className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg px-3 py-[7px] w-full md:w-auto md:min-w-[260px] focus-within:border-red-400 focus-within:ring-1 focus-within:ring-red-400/20 transition-all shrink-0">
        <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          className="bg-transparent border-none outline-none text-[13px] text-gray-900 w-full placeholder:text-gray-400"
          placeholder="Buscar por nombre, email..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <select
        className="w-full md:w-auto md:ml-auto bg-white border border-gray-300 rounded-lg py-2 md:py-1.5 px-2.5 text-xs text-gray-700 outline-none cursor-pointer transition-all hover:border-gray-400 hover:bg-gray-50 focus:border-red-400 focus:ring-1 focus:ring-red-400/20 shadow-sm shrink-0"
        value={sortOrder}
        onChange={(e) => onSortChange(e.target.value)}
      >
        <option value="mostReported">Con más denuncias</option>
        <option value="recentComplaint">Denuncias más recientes</option>
      </select>
    </div>
  );
};

export default ReportedUserFilterToolbar;